import { FDRStatus } from '@cibo/core'
import { ExtendedTheme, stripedLinearGradient } from '@cibo/ui'
import { Typography, TypographyProps, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ProgramOpportunityDisplayProps } from './ProgramOpportunityTypes'

// eslint-disable-next-line complexity
export const ProgramOpportunityBanner = ({
  enrollmentCount,
  opportunities,
  program,
  stat,
  sx = {},
  ...typographyProps
}: Pick<ProgramOpportunityDisplayProps, 'program' | 'enrollmentCount' | 'opportunities' | 'stat'> &
  TypographyProps) => {
  const {
    palette: { warning, info, success, programEnrollmentClosed, programClosed, future },
  } = useTheme<ExtendedTheme>()
  const { t } = useTranslation('impact/pages/ProgramOpportunityBanner')
  const now = new Date()
  const closeDate = new Date(program?.enrollmentWindow.closeDate ?? now)

  const isEnrollmentClosed = program?.enrollmentWindow.enrollmentStatus === 'closed'
  const isProgramClosed = closeDate.valueOf() < now.valueOf()
  const isEnrollmentFuture = program?.enrollmentWindow.enrollmentStatus === 'future'
  const someRewards = opportunities?.some(
    ({ fields, status }) => !!fields && status === FDRStatus.eligibleForEnrollment
  )

  const colors = []
  !!enrollmentCount && colors.push(warning.light)
  !!stat?.committed.fields && colors.push(success.light)
  !!someRewards && colors.push(isEnrollmentFuture ? future.main : info.light)
  !!isEnrollmentFuture && !someRewards && colors.push(future.main)
  !!isEnrollmentClosed && !isProgramClosed && colors.push(programEnrollmentClosed.main)
  !!isProgramClosed && colors.push(programClosed.main)

  const label = !!enrollmentCount
    ? t('enrollmentCount', { count: enrollmentCount })
    : !!someRewards
    ? t('potentialRewards')
    : !!stat?.committed.fields
    ? t('enrolled')
    : !!isProgramClosed
    ? t('programClosed')
    : !!isEnrollmentClosed
    ? t('programEnrollmentClosed')
    : !!isEnrollmentFuture
    ? t('future')
    : undefined

  if (!!colors.length && label) {
    return (
      <Typography
        color="success.contrastText"
        variant="overline"
        sx={{
          background: stripedLinearGradient(colors, 110, 65),
          paddingInline: 1,
          display: 'block',
          ...sx,
        }}
        {...typographyProps}
      >
        {label}
      </Typography>
    )
  }
  return null
}
